import { NormalizedCacheObject } from 'apollo-boost';

import {
    resetAutoOverdraftLimit,
    setAutoOverdraftLimit
} from '../../graphql/mutations/grid/wallet';
import {
    ResetAutoOverdraftLimit,
    SetAutoOverdraftLimit
} from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class WalletMutationExecutor {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public async setAutoOverdraftLimit(
        paymentMethodCode: string,
        personId: number,
        autoOverdraftLimit: number | null
    ): Promise<SetAutoOverdraftLimit> {
        const result = await this.client.mutate<SetAutoOverdraftLimit>({
            mutation: setAutoOverdraftLimit,
            variables: {
                input: {
                    paymentMethodCode,
                    personId,
                    autoOverdraftLimit
                }
            }
        });

        return result.data as SetAutoOverdraftLimit;
    }

    public async resetAutoOverdraftLimit(): Promise<ResetAutoOverdraftLimit> {
        const result = await this.client.mutate<ResetAutoOverdraftLimit>({
            mutation: resetAutoOverdraftLimit,
            variables: {}
        });

        return result.data as ResetAutoOverdraftLimit;
    }
}
